import { EAttributeType } from '../../@types/AttributeTypes';
import Entity, { IEntity } from '../abstract/Entity';
import AttributeModel, { IAttribute } from './AttributeModel';

export interface IObjectLocalization {
  cz?: string;
  de?: string;
  en?: string;
  es?: string;
  fr?: string;
  hr?: string;
  it?: string;
  ja?: string;
  nl?: string;
  pl?: string;
  pt?: string;
  ro?: string;
  rs?: string;
  ru?: string;
  tr?: string;
  [languageCode: string]: string | undefined;
}

export interface IIfcObjectTag {
  ifcClass?: string;
  ifcType?: string;
}

export interface IObject extends IEntity {
  id: number;
  name: string;
  localization?: IObjectLocalization;
  ifcObject?: IIfcObjectTag;
  toJSON: any;
}

export class ObjectModel extends Entity implements IObject {
  id: number;
  name: string;
  localization?: IObjectLocalization;
  ifcObject?: IIfcObjectTag;

  constructor(
    id: number, 
    name: string, 
    attributes: Array<IAttribute> = [], 
    uuid: string | undefined = undefined,
    localization?: IObjectLocalization,
    ifcObject?: IIfcObjectTag
  ) {
    super(attributes);
    if (uuid) {
      this.uuid = uuid;
    }
    this.id = id;
    this.name = name;
    this.localization = localization;
    this.ifcObject = ifcObject;
  }

  static fromJSON(json: any): ObjectModel {
    const attributes =
      json.attributes?.map((attr: any, i: number) => {
        const predecessorId = i === 0 ? null : json.attributes[i - 1].id;
        
        const typeMap: Record<string, EAttributeType> = {
          TEXT: EAttributeType.TEXT,
          NUMBER: EAttributeType.NUMBER,
          BOOL: EAttributeType.BOOL,
          SELECTION: EAttributeType.SELECTION,
          PLAIN: EAttributeType.PLAIN
        };
        const type = typeMap[attr.type] || EAttributeType.TEXT; 

        return new AttributeModel(
          Number(attr.id), 
          attr.key || '', 
          attr.value, 
          predecessorId, 
          type, 
          attr.unit || null, 
          attr.hidden, 
          attr.forced,
          attr.ownerId,
          attr.userId,
          attr.publicFlag,
          attr.localization,
          attr.defaults,
          attr.validation,
          attr.unitFamily
        );
      }) || [];

    return new ObjectModel(
      json.id, 
      json.name, 
      attributes, 
      json.uuid,
      json.localization, 
      json.ifcObject
    );
  }

  toJSON() {
    return {
      ...super.toJSON(),
      id: this.id,
      name: this.name,
      localization: this.localization,
      ifcObject: this.ifcObject,
      attributes: this.attributes.map((attr) => ({
        id: attr.id,
        key: attr.key,
        value: attr.value,
        predecessorId: attr.predecessorId,
        type: attr.type,
        unit: attr.unit,
        hidden: attr.hidden,
        forced: attr.forced,
        ownerId: attr.ownerId,
        userId: attr.userId,
        publicFlag: attr.publicFlag,
        localization: attr.localization,
        defaults: attr.defaults,
        validation: attr.validation,
        unitFamily: attr.unitFamily,
      })),
    };
  }
}

export default ObjectModel;